<div class="admin-main-page">
    <div id="savePnl" class="col-12 text-end  save-pnl">
        <button style="width: 100px;" class="button darkblue"
                (click)="saveMainPage()">
            <span i18n="@@Save">Save</span>
        </button>
    </div>

    <p-accordion [activeIndex]="0">
        <p-accordionTab i18n-header="@@Top Bar" header="Top Bar">
            <div class="flex">
                <div class="col-12 lg:col-6">
                    <div><label i18n="@@Text">Text</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="mainPageConfig['top-bar']['text']">
                </div>
                <div class="col-12 lg:col-6">
                    <div><label i18n="@@page">page</label></div>
                    <p-dropdown [options]="pageList" [(ngModel)]="mainPageConfig['top-bar']['page']" optionLabel="name"
                                [style]="{'width': '100%'}"
                                [filter]="true" (onFilter)="fillSelectPage($event)"
                                filterBy="name" [showClear]="true" placeholder="Select a page">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex align-items-center gap-2">
                                <div>{{ selectedOption.name }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-page pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div>{{ page.name }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>

                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Title Section" header="Title Section">
            <div class="flex flex-wrap">
                <div class="col-12" style="direction: ltr;min-height: 400px;height: 100%;">
                    <div><label>Html Code</label></div>
                    <textarea style="width: 100%;direction: ltr;min-height: 400px;" pInputText
                              [(ngModel)]="mainPageConfig['title-section']['text1']"></textarea>
                    <!--                <ngx-monaco-editor [style]="{'min-height':'300px','direction':'ltr'}" [options]="editorOptions" [(ngModel)]="mainPageConfig['title-section']['text1']"></ngx-monaco-editor>-->
                </div>


            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Business bar" header="Business bar">
            <div class="flex">
                <div class="col-12 lg:col-4">
                    <div><label i18n="@@page">page</label></div>
                    <p-dropdown [options]="pageList" [(ngModel)]="newBusiness['page']" optionLabel="name"
                                [style]="{'width': '100%'}"
                                (onChange)="selectBusnessPage()"
                                [filter]="true" (onFilter)="fillSelectPage($event)"
                                filterBy="name" [showClear]="true" placeholder="Select a page">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex align-items-center gap-2">
                                <div>{{ selectedOption.name }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-page pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div>{{ page.name }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <!--                <div class="col-12 lg:col-3">-->
                <!--                    <div><label i18n="@@color Photo">color Photo</label></div>-->
                <!--                    <div style="text-align: center;width: 100%;">-->
                <!--                        <img (click)="addBusinessLogoImage( '1')"-->
                <!--                             *ngIf="newBusiness['c-img-uid']!= null && newBusiness['c-img-uid'].length>0"-->
                <!--                             style="height: 40px;border-radius: 10px;"-->
                <!--                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +newBusiness['c-img-uid'] ">-->
                <!--                    </div>-->
                <!--                    <div (click)="addBusinessLogoImage( '1')" style="margin-top: 11px;"-->
                <!--                         *ngIf="newBusiness['c-img-uid']==null || newBusiness['c-img-uid'].length<1">-->
                <!--                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"-->
                <!--                             fill="#000000">-->
                <!--                            <path d="M0 0h24v24H0V0z" fill="none"/>-->
                <!--                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>-->
                <!--                        </svg>-->
                <!--                    </div>-->

                <!--                </div>-->
                <!--                <div class="col-12 lg:col-3">-->
                <!--                    <div><label i18n="@@white Photo">white Photo</label></div>-->
                <!--                    <div style="text-align: center;width: 100%;">-->
                <!--                        <img (click)="addBusinessLogoImage( '2')"-->
                <!--                             *ngIf="newBusiness['w-img-uid']!= null && newBusiness['w-img-uid'].length>0"-->
                <!--                             style="height: 40px;border-radius: 10px;background-color: #d0d5d5;margin: 0px 20px;padding: 0px 10px;"-->
                <!--                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +newBusiness['w-img-uid'] ">-->
                <!--                    </div>-->
                <!--                    <div (click)="addBusinessLogoImage('2')" style="margin-top: 11px;"-->
                <!--                         *ngIf="newBusiness['w-img-uid']==null || newBusiness['w-img-uid'].length<1">-->
                <!--                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"-->
                <!--                             fill="#000000">-->
                <!--                            <path d="M0 0h24v24H0V0z" fill="none"/>-->
                <!--                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>-->
                <!--                        </svg>-->
                <!--                    </div>-->

                <!--                </div>-->
                <div class="col-2 cursor-pointer">
                    <p-button [disabled]="newBusiness['c-img-uid']==null || newBusiness['c-img-uid'].length<1
                 ||newBusiness['w-img-uid']==null || newBusiness['w-img-uid'].length<1 ||
                newBusiness['page']==null " [style]="{'margin-top': '25px'}" (click)="addToBusnessBarList()">
                        <span i18n="@@Add">Add</span>
                    </p-button>
                </div>
            </div>
            <div class="flex flex-wrap">
                <ng-container *ngFor="let busi of mainPageConfig['business-bar']">
                    <div class="flex"
                         style="border-radius: 5px;border: 1px solid #9a9a9a;margin:0px 5px;font-size: 12px;">
                        <div style="    width: fit-content;padding: 0px 10px;top: 11px;position: relative;">{{busi['page']['name']}}</div>
                        <img style="height: 46px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +busi['c-img-uid'] ">
                        <img style="height: 46px;border-radius: 10px;background-color: #d0d5d5;margin: 0px 20px;padding: 0px 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +busi['w-img-uid'] ">
                        <div class="col-1">
                            <i class="pi pi-trash cursor-pointer" style="position: relative;top: 6px;"
                               (click)="removeFromBusinessList(busi)"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Brands" header="Brands">
            <div class="col-12">
                <p-inputSwitch [(ngModel)]="mainPageConfig['active-items']['brands']"></p-inputSwitch>
            </div>
            <div class="flex">

                <div class="col-12 lg:col-3">
                    <div><label i18n="@@color Photo">color Photo</label></div>
                    <div style="text-align: center;width: 100%;">
                        <img (click)="addBrandLogoImage( '1')"
                             *ngIf="newBrand['img-uid']!= null && newBrand['img-uid'].length>0"
                             style="height: 40px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +newBrand['img-uid'] ">
                    </div>
                    <div (click)="addBrandLogoImage( '1')" style="margin-top: 11px;"
                         *ngIf="newBrand['img-uid']==null || newBrand['img-uid'].length<1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="#000000">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                        </svg>
                    </div>

                </div>
                <div class="col-2 cursor-pointer">
                    <p-button [disabled]="newBrand['img-uid']==null || newBrand['img-uid'].length<1 "
                              [style]="{'margin-top': '25px'}" (click)="addToBrandList()">
                        <span i18n="@@Add">Add</span>
                    </p-button>
                </div>
            </div>
            <div class="flex flex-wrap">
                <ng-container *ngFor="let brand of mainPageConfig['brands']">
                    <div class="flex"
                         style="border-radius: 5px;border: 1px solid #9a9a9a;margin:0px 5px;font-size: 12px;">
                        <img style="height: 46px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +brand['img-uid'] "
                        [alt]="brand['img-name']">

                        <div class="col-1">
                            <i class="pi pi-trash cursor-pointer" style="position: relative;top: 6px;"
                               (click)="removeFromBrandList(brand)"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Abstract Bar" header="Abstract Bar">
            <div class="flex">
                <div class="col-12 lg:col-4">
                    <div><label i18n="@@Text">Text</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="newAbstract['text']">
                </div>
                <div class="col-12 lg:col-5">
                    <div><label i18n="@@Photo">Photo</label></div>
                    <div style="text-align: center;width: 100%;">
                        <img (click)="addAbstractLogoImage( )"
                             *ngIf="newAbstract['img-uid']!= null && newAbstract['img-uid'].length>0"
                             style="height: 40px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +newAbstract['img-uid'] ">
                    </div>
                    <div (click)="addAbstractLogoImage( )" style="margin-top: 11px;"
                         *ngIf="newAbstract['img-uid']==null || newAbstract['img-uid'].length<1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="#000000">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                        </svg>
                    </div>

                </div>
                <div class="col-3 ">
                    <p-button [disabled]="newAbstract['img-uid']==null || newAbstract['img-uid'].length<1 ||
                newAbstract['text'].length<= 1 " [style]="{'margin-top': '25px'}" (click)="addToAbstractList()">
                        <span i18n="@@Add">Add</span>
                    </p-button>
                </div>
            </div>
            <div class="flex flex-wrap">
                <ng-container *ngFor="let abst of mainPageConfig['abstract-bar']">
                    <div class="flex"
                         style="border-radius: 5px;border: 1px solid #9a9a9a;margin:0px 5px;font-size: 12px;">
                        <div style="    width: fit-content;padding: 0px 10px;top: 11px;position: relative;">{{abst['text']}}</div>
                        <img style="height: 46px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +abst['img-uid'] ">
                        <div class="col-1">
                            <i class="pi pi-trash cursor-pointer" style="position: relative;top: 6px;"
                               (click)="removeFromAbstractList(abst)"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Success Stories" header="Success Stories">
            <div class="col-12">
                <p-inputSwitch [(ngModel)]="mainPageConfig['active-items']['SuccessStories']"></p-inputSwitch>
            </div>
            <div class="col-12 ">
                <div><label i18n="@@Text">Text</label></div>
                <textarea style="width: 100%;" pInputTextarea
                          [(ngModel)]="mainPageConfig['success_stories']['title']"></textarea>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Service Features" header="Service Features">
            <div class="col-12">
                <p-inputSwitch [(ngModel)]="mainPageConfig['active-items']['ServiceFeatures']"></p-inputSwitch>

            </div>
            <div class="col-12 ">
                <div><label i18n="@@Text">Text</label></div>
                <textarea style="width: 100%;" pInputTextarea
                          [(ngModel)]="mainPageConfig['service_features']['title']"></textarea>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Developer Help" header="Developer Help">
            <div class="flex flex-wrap">
                <div class="col-12 ">
                    <div><label i18n="@@Title">Title</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="mainPageConfig['developer-bar']['title']">
                </div>
                <div class="col-12 ">
                    <div><label i18n="@@Text">Text</label></div>
                    <textarea style="width: 100%;" pInputTextarea
                              [(ngModel)]="mainPageConfig['developer-bar']['text']"></textarea>
                </div>
                <div class="col-12 lg:col-6">
                    <div><label i18n="@@Photo">Photo</label></div>
                    <div style="text-align: center;width: 100%;">
                        <img (click)="addDeveloperImage( )"
                             *ngIf="mainPageConfig['developer-bar']['img-uid']!= null && mainPageConfig['developer-bar']['img-uid'].length>0"
                             style="height: 40px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +mainPageConfig['developer-bar']['img-uid'] ">
                    </div>
                    <div (click)="addDeveloperImage()" style="margin-top: 11px;"
                         *ngIf="mainPageConfig['developer-bar']['img-uid']==null || mainPageConfig['developer-bar']['img-uid'].length<1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="#000000">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                        </svg>
                    </div>

                </div>
                <div class="col-12 lg:col-6 ">
                    <div><label>Url</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="mainPageConfig['developer-bar']['url']">
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Performance" header="Performance">
            <div class="flex flex-wrap">
                <div class="col-12 ">
                    <div><label i18n="@@Title">Title</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="mainPageConfig['performance-bar']['title']">
                </div>
                <div class="col-12 ">
                    <div><label i18n="@@Text">Text</label></div>
                    <textarea style="width: 100%;" pInputTextarea
                              [(ngModel)]="mainPageConfig['performance-bar']['text']"></textarea>
                </div>
                <div class="col-12 ">
                    <div><label>Url</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="mainPageConfig['performance-bar']['url']">
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Footer" header="Footer">
            <div class="flex">
                <div class="col-12 lg:col-4">
                    <div><label i18n="@@Menu Name">Menu Name</label></div>
                    <input style="width: 100%;" pInputText [(ngModel)]="newfooterCategory">
                </div>
                <div class="col-3 ">
                    <p-button [disabled]=" newfooterCategory.length<1" [style]="{'margin-top': '25px'}"
                              (click)="addFooterCategory()">
                        <span i18n="@@Add">Add</span>
                    </p-button>
                </div>

            </div>
            <div class="footer-link flex flex-wrap">
                <ng-container *ngFor="let category of mainPageConfig['footer'] ">
                    <div class="col-12 lg:col-4 " style="margin-bottom: 40px;">
                        <div class="footer-cat flex">
                            <input style="width: 100%;margin: 0px 5px;"  pInputText
                                   [(ngModel)]="category.name">
                            <i style="margin: 0px 5px;color: red;" class="pi pi-minus-circle cursor-pointer"
                               (click)="removeCategory(category)"></i>
                        </div>

                        <ng-container *ngFor="let link of category['links']">
                            <div class="flex"  style="padding: 5px;">
<!--                                <a style="width: calc(100% - 60px);" [href]="link['path']">{{link['title']}}</a>-->
                                <input style="width: 100%;margin: 0px 5px;"  pInputText
                                       [(ngModel)]="link['title']">
                                <input style="width: 100%;margin: 0px 5px;"  pInputText
                                       [(ngModel)]="link['path']">
                                <i class="pi pi-minus-circle cursor-pointer" style="margin: 0px 5px;color: red;"
                                   (click)="removeFromFooterCatLink(category,link['title'])"></i>
<!--                                <i class="pi pi-pencil cursor-pointer" style="margin: 0px 5px;color: #ff9700;"-->
<!--                                   (click)="editFromFooterCatLink(category ,link['title'],link['path'])"></i>-->
                            </div>

                        </ng-container>
                        <div style="text-align: center;">
                            <i class="pi pi-plus-circle cursor-pointer" style="padding: 5px 10px;color: green;"
                               (click)="addFooterCatLink(category)"></i>
                        </div>
<!--                        <div class="flex">-->
<!--                            <input style="width: 100%;margin: 0px 5px;" placeholder="Title" pInputText-->
<!--                                   [(ngModel)]="newfooterLinkTitle[category.name]">-->
<!--                            <input style="width: 100%;margin: 0px 5px;" placeholder="Path" pInputText-->
<!--                                   [(ngModel)]="newfooterLinkPath[category.name]">-->
<!--                            <i class="pi pi-plus-circle cursor-pointer" style="padding: 5px 10px;color: green;"-->
<!--                               (click)="addFooterCatLink(category)"></i>-->
<!--                        </div>-->

                    </div>
                </ng-container>
            </div>
        </p-accordionTab>
        <p-accordionTab i18n-header="@@Bottom bar" header="Bottom bar">
            <div class="flex flex-wrap">
                <div class="col-12 ">
                    <div><label i18n="@@Text">Text</label></div>
                    <textarea style="width: 100%;" pInputTextarea
                              [(ngModel)]="mainPageConfig['bottom-bar']['text']"></textarea>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab  header="Copyright">
            <div class="flex flex-wrap">
                <div class="col-12 ">
                    <div><label i18n="@@Text">Text</label></div>
                    <textarea style="width: 100%;" pInputTextarea
                              [(ngModel)]="mainPageConfig['copyright']['text']"></textarea>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab  i18n-header="@@social network" header="social network">
            <div class="flex flex-wrap">
                    <ng-container *ngFor="let social of mainPageConfig['social-networks']" >
                            <div class="col-6">
                                <input style="width: 100%;direction: ltr;" [(ngModel)]="social.url">
                            </div>
                            <div class="col-5">
                                <select style="width: 100%"
                                        [(ngModel)]="social.type">
                                    <option value="Instagram">Instagram</option>
                                    <option value="Linkedin">Linkedin</option>
                                    <option value="Aparat">Aparat</option>
                                    <option value="Youtube">Youtube</option>
                                    <option value="Facebook">Facebook</option>
                                </select>
                            </div>
                    </ng-container>
                <div class="col-1">
                    <i  style="margin-top: 17px;" class="pi pi-plus-circle cursor-pointer" (click)="addSocialNetwork()"></i>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

</div>


<p-dialog i18n-header="@@Image Manager" header="Image Manager" [resizable]="false"
          [(visible)]="displayImageCenter"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'90%'}">
    <div class="  lg:col-12">
        <app-image-manager [imgSelected]="imgManagerTemp"
                           (selectImageEvent)="selectPhotoItem($event)"></app-image-manager>
    </div>
</p-dialog>
